// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__PvEbc","spinner":"Loader_spinner__QrU8H","spin":"Loader_spin__8TnK+","loaderText":"Loader_loaderText__oOLxt"};